import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useApi } from '../services/api';
import { UserRole } from '@bst-stellar/shared';

export default function ProfilePage() {
    const { user } = useAuth();
    const api = useApi();
    const [name, setName] = useState(user?.name || '');
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    const canEditName = user?.role === UserRole.COMPANY_ADMIN || user?.role === UserRole.DEPT_ADMIN;

    async function handleSave(e: React.FormEvent) {
        e.preventDefault();
        try {
            setSaving(true);
            await api.updateProfile({ name });
            setMessage('Profile updated successfully!');
        } catch (error) {
            setMessage('Failed to update profile');
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="max-w-2xl mx-auto py-8 px-4">
            <h1 className="text-3xl font-bold mb-6 text-text-primary">Profile Settings</h1>

            <div className="bg-surface rounded-lg shadow p-6 border border-border">
                <form onSubmit={handleSave}>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-text-secondary mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            value={user?.email || ''}
                            disabled
                            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text-muted"
                        />
                        <p className="text-xs text-text-muted mt-1">Email cannot be changed</p>
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-text-secondary mb-2">
                            Display Name
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={!canEditName}
                            className={`w-full px-3 py-2 border border-border rounded-lg bg-surface text-text-primary focus:ring-2 focus:ring-primary focus:outline-none ${!canEditName ? 'bg-background text-text-muted cursor-not-allowed' : ''}`}
                        />
                        {!canEditName && (
                            <p className="text-xs text-text-muted mt-1">
                                Only administrators can change display names. Please contact your admin for assistance.
                            </p>
                        )}
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-text-secondary mb-2">
                            Role
                        </label>
                        <input
                            type="text"
                            value={user?.role || ''}
                            disabled
                            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text-muted capitalize"
                        />
                    </div>

                    {message && (
                        <div className={`mb-4 p-3 rounded-lg ${message.includes('success') ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'}`}>
                            {message}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={saving}
                        className="btn-primary w-full"
                    >
                        {saving ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </div>
        </div>
    );
}
